import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { createFormResolver } from '@mews-commander/form';
import { validation as validate } from '@mews-commander/legacy-form';
import { getEditValue } from '../../enterpriseRateManagement/utilities';
import { usePropertiesGroupsData, useUpdatePropertyGroup } from '../queries';
import { DEFAULT_VALUES, FormValues } from './PropertyGroupDialog/types/Form';
import { FORM_TYPE, getConstraints } from './PropertyGroupDialog/constraints';
import { PropertyGroupDialogForm } from './PropertyGroupDialog/PropertyGroupDialog';

interface EditPropertyGroupContainerProps {
    selectedPropertyGroup: PortfolioEnterpriseGroupResult;
    isOpened: boolean;
    onCancel: () => void;
    onConfirm: () => Promise<void>;
    onSuccess?: () => void;
}

export const EditPropertyGroupContainer = ({
    selectedPropertyGroup,
    onSuccess,
    onConfirm,
    onCancel,
    isOpened,
}: EditPropertyGroupContainerProps) => {
    const updatePropertyGroup = useUpdatePropertyGroup();
    const { data: propertyGroups } = usePropertiesGroupsData();

    const resolver = createFormResolver<FormValues>(
        validate(getConstraints(FORM_TYPE.EDIT, propertyGroups?.data || [], selectedPropertyGroup))
    );

    const formProps = {
        resolver,
        defaultValues: DEFAULT_VALUES,
        values: selectedPropertyGroup,
    };

    const onEditSuccess = (propertyGroup: PortfolioEnterpriseGroupResult) => {
        showSuccessAlert({
            title: lt('SavedChangesToPropertyGroup', {
                propertyGroupName: propertyGroup.name,
            }),
        });
        onSuccess?.();
    };

    const onSubmit = (values: FormValues) => {
        updatePropertyGroup.mutate(
            {
                description: getEditValue(values.description),
                name: getEditValue(values.name),
                id: selectedPropertyGroup.id,
            },
            {
                onSuccess: onEditSuccess,
            }
        );
    };

    return (
        <PropertyGroupDialogForm
            useFormProps={formProps}
            onConfirm={onConfirm}
            onCancel={onCancel}
            isLoading={updatePropertyGroup.isPending}
            onSubmit={onSubmit}
            active={isOpened}
            selectedPropertyGroup={selectedPropertyGroup}
            activeTabValue={FORM_TYPE.EDIT}
            setActiveTabValue={() => {}}
            enterpriseIds={[]}
        />
    );
};
